import qs from 'qs';
import { showToast } from 'stores/ToastStore';
import i18next from 'i18next';
import client from './rest/AdminClient';
export async function getQuickPayContracts({ queryKey }) {
    const [, id] = queryKey;
    const query = { user: id };
    try {
        const queryString = qs.stringify(query);
        const result = await client({
            method: 'GET',
            path: '/admin/api/quickpay/contract?' + queryString,
        });
        return result.entity.contracts;
    }
    catch (e) {
        showToast(i18next.t('FAILED_FETCH_CONTRACTS'), i18next.t('FAILED_FETCH_CONTRACTS'), 'error');
        return [];
    }
}
export async function getExpiredQuickPayContracts({ queryKey }) {
    const [, id] = queryKey;
    try {
        const result = await client({
            method: 'GET',
            path: `/admin/api/quickpay/history/${id}`,
        });
        return result.entity.history;
    }
    catch (e) {
        showToast(i18next.t('FAILED_FETCH_CONTRACTS'), i18next.t('FAILED_FETCH_CONTRACTS'), 'error');
        return [];
    }
}
export async function createQuickPayContract(contract) {
    const result = await client({
        method: 'POST',
        path: '/admin/api/quickpay/contract',
        entity: JSON.stringify({ contract }),
    });
    return result.entity;
}
export async function updateActiveQuickPayContract({ contractId, updates }) {
    const result = await client({
        method: 'PUT',
        path: `/admin/api/quickpay/${contractId}`,
        entity: JSON.stringify({ updates }),
    });
    return result.entity;
}
export async function updateQuickPayContract({ contractId, updates }) {
    const result = await client({
        method: 'PATCH',
        path: `/admin/api/quickpay/${contractId}`,
        entity: JSON.stringify({ updates }),
    });
    return result.entity;
}
export async function getTermsAndConditions() {
    try {
        const result = await client({
            method: 'GET',
            path: `/admin/api/contracts/terms`,
        });
        return result.entity.items;
    }
    catch (e) {
        showToast(i18next.t('FAILED_FETCH_T&C'), i18next.t('FAILED_FETCH_T&C'), 'error');
    }
}
